import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { TeamType } from 'webapp/enums/enums';

import type Team from 'webapp/models-custom/team';
import type TeamRecord from 'webapp/models/team';

export default class TeamsViewRoute extends Route {
	@service('model-manager/teams') declare mmTeamsService: Service.ModelManager.Teams;
	@service('model-manager/board-loops')
	declare mmBoardLoopsService: Service.ModelManager.BoardLoops;
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;
	// @service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;
	@service('model-manager/metrics')
	declare mmMetricsService: Service.ModelManager.Metrics;
	@service('store') declare storeService: Service.Store;
	@service('navigation') declare navigationService: Service.Navigation;

	override queryParams = {
		action: {
			refreshModel: true,
		},
	};

	override beforeModel() {
		document.body.id = 'page-teams-view';

		const promises: Promise<unknown>[] = [];
		promises.push(this.navigationService.initialRequestsPromise);
		promises.push(this.mmTeamsService.requestTeams());
		promises.push(this.mmBoardLoopsService.requestBoardLoops());
		promises.push(this.mmReportsService.requestReports());
		// promises.push(this.mmGoalsService.requestSpaceGoals());
		promises.push(this.mmMetricsService.requestMetrics());

		// this.mmGoalsService.requestSpaceGoalsData();

		return Promise.all(promises);
	}

	override async model(params: { team_id: string; action?: string }): Promise<Team | void> {
		let model: Team | null = null;

		if (params) {
			const teamRecord = this.storeService.peekRecord('team', params.team_id) as TeamRecord;

			if (teamRecord) {
				model = this.mmTeamsService.createModelFromRecord(teamRecord);
			}
		}

		if (!model) {
			this.navigationService.replaceRoute('index');
			return;
		} else if (model.type !== TeamType.OPEN && !model.isUserMember) {
			this.navigationService.replaceRoute('teams');
			return;
		}

		await this.mmTeamsService.requestSections(model.id!);
		await this.mmTeamsService.requestData(model.id!);

		if (params.action === 'open-members-popup') {
			this.mmTeamsService.openManageTeamMembersPopup(model);
		}

		return model;
	}
}
